import {
  CancelOrderReportQueryResponseResponseMessage,
  DeliveryProviderName,
  MenuItemsDto,
  MyOrderListQueryResponse,
  MyOrderListQueryResponsePaginatedListResponseMessage,
  OrderCreatedResponse,
  OrderCreatedResponseResponseMessage,
  OrderItemQueryResponse,
  OrderItemToppingQueryResponse,
  OrderItemToppingUpdatedResponse,
  OrderItemUpdatedResponse,
  OrderListQueryResponse,
  OrderListQueryResponsePaginatedList,
  OrderListQueryResponsePaginatedListResponseMessage,
  OrderPatchRequest,
  OrderQueryResponse,
  OrderQueryResponseResponseMessage,
  OrderState,
  OrderType,
  OrderUpdatedEvent,
  OrderUpdatedEventResponseMessage,
  PaymentMethod,
} from '../../ropolo';

export type OrderResponse = OrderListQueryResponse;
export type OrderDetailsResponse = OrderQueryResponse;

export type OrderItemToppingUpdatedPayload = OrderItemToppingUpdatedResponse;
export type OrderDetailsItem = OrderItemQueryResponse;
export type OrderItemTopping = OrderItemToppingQueryResponse;
export type MyOrdersResponse = MyOrderListQueryResponsePaginatedListResponseMessage;
export type OrderByIdResponse = OrderQueryResponseResponseMessage;
export type OrdersResponseMessage = OrderListQueryResponsePaginatedListResponseMessage;
export type OrdersResponse = OrderListQueryResponsePaginatedList;
export type MyOrder = MyOrderListQueryResponse;
export type OrderCreateResponse = OrderCreatedResponseResponseMessage;
export type OrderCreateIdResponse = OrderCreatedResponse;
export type OrderChangeStatus = OrderPatchRequest;
export type OrderCreatedResponseResponse = OrderCreatedResponseResponseMessage;
export type FoodMenuItem = MenuItemsDto;

export type OrderUpdatedEventResponse = OrderUpdatedEventResponseMessage;
export type OrderUpdatedPayload = OrderUpdatedEvent;
export type OrderItemUpdatedPayload = OrderItemUpdatedResponse;

export const OrderTypeEnums: Record<OrderType, string> = {
  WEBSITE: 'WEBSITE',
  QR: 'QR',
  SALON: 'SALON',
  SNAPPFOOD: 'SNAPPFOOD',
  KIOSK: 'KIOSK',
};
export type CancelOrderReportQueryResponseResponse = CancelOrderReportQueryResponseResponseMessage;
export type DeliveryType = 'DELIVER' | 'PICKUP' | 'SERVE' | 'ZFEXPRESS';

export const DeliveryTypes = {
  SERVE: 'سرو در محل',
  DELIVER: 'ارسال با پیک',
  PICKUP: 'تحویل حضوری',
  ZFEXPRESS: 'پیک اکسپرس',
};

export const OrderTypes = {
  WEBSITE: 'سایت',
  QR: 'آنلاین',
  SALON: 'سالن',
  SNAPPFOOD: 'اسنپ فود',
  KIOSK: 'کیوسک',
};

export const BasePaymentTypes = {
  CARD: 'کارت',
  CASH: 'نقدی',
};

export const PaymentTypes = {
  ...BasePaymentTypes,
  [PaymentMethod.CREDIT]: 'اعتباری',
  [PaymentMethod.UNPAID]: 'پرداخت پیامکی',
  [PaymentMethod.FOODRO]: 'فودرو',
};

export const PaymentOrderDetailsTypes = {
  CARD: 'کارت',
  CASH: 'نقدی',
  ONLINE: 'آنلاین',
  UNPAID: 'پرداخت نشده',
  FOODRO: 'فودرو',
  [PaymentMethod.CREDIT]: 'اعتباری',
};

export const PaymentOrderDetailsDescriptionTypes = {
  CARD: 'پرداخت با کارت',
  CASH: 'پرداخت نقدی',
  ONLINE: 'تسویه آنلاین',
  UNPAID: 'پرداخت نشده',
};

export const OrderStateType = {
  [OrderState.CONFIRMED]: 'تایید شده',
  [OrderState.DELIVERED]: 'تحویل داده شده',
  [OrderState.DELIVERING]: 'در حال ارسال',
  [OrderState.FINISHED]: 'تمام شده',
  [OrderState.PAID]: 'پرداخت شده',
  [OrderState.READYTOSHIPMENT]: 'آماده ارسال',
  [OrderState.READYTOPICKUP]: 'آماده تحویل',
  [OrderState.READYTOSERVE]: 'آماده سرو',
  [OrderState.REJECTED]: 'رد شده',
  [OrderState.SUBMITTED]: 'ثبت شده',
};

export const DeliveryProviderType = {
  [DeliveryProviderName.MIARE]: {
    label: 'میاره',
    src: '/img/delivery-logo/miare-logo.png',
  },
  [DeliveryProviderName.SNAPPBOX]: {
    label: 'اسنپ باکس',
    src: '/img/delivery-logo/snappbox-logo.png',
  },
  [DeliveryProviderName.BORDAR]: {
    label: 'بردار',
    src: '/img/delivery-logo/bordar-logo.png',
  },
  [DeliveryProviderName.EXPRESSPLUS]: {
    label: 'اسنپ اکسپرس',
    src: null,
  },
  OWN_FLEET: {
    label: 'پیک رستوران',
    src: null,
  },
};
